// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ComposedBlock_wrapper__8ZxhT","secondaryWrapper":"ComposedBlock_secondaryWrapper__fvsHE"};